/**************************************************
 * Nombre:       ListaLocales
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid} from "@mui/material";
import Tarjeta_Local from "../../../Tarjetas/Tarjeta_Local";
import {DIRECCIONLOCALES} from "../../../../Constantes";

const ListaLocales = () => {

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid id={DIRECCIONLOCALES[0].nombre} container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                <Tarjeta_Local izq={true} item={DIRECCIONLOCALES[0]}  />
            </Grid>

            <Grid id={DIRECCIONLOCALES[1].nombre} container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 8}}>
                <Tarjeta_Local izq={false} item={DIRECCIONLOCALES[1]}/>
            </Grid>

            <Grid id={DIRECCIONLOCALES[2].nombre} container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 8}}>
                <Tarjeta_Local izq={true} item={DIRECCIONLOCALES[2]}/>
            </Grid>

            <Grid id={DIRECCIONLOCALES[3].nombre} container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 8}}>
                <Tarjeta_Local izq={false} item={DIRECCIONLOCALES[3]}/>
            </Grid>

            <Grid id={DIRECCIONLOCALES[3].nombre} container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 8}}>
                <Tarjeta_Local izq={true} item={DIRECCIONLOCALES[4]}/>
            </Grid>

        </Grid>
    )

}
export default ListaLocales    